<script setup>
</script>

<template>
  <div class="about" id="about">
    <div class="container">
      <div class="about__wrapper">
        <img
            src="@images/about-image.png"
            alt=""
            class="about__wrapper-left"
        />
        <div class="about__wrapper__right">
          <div class="about__wrapper__right-text">
            <h2>Who We Are</h2>
            <p>
              Gold-Charge is a next-generation payment platform built to help
              merchants accept and manage online payments globally.
            </p>
            <p>
              From startups to enterprises, we enable seamless transactions,
              advanced analytics, and total control — all through a single,
              powerful dashboard.
            </p>
          </div>
          <img src="@images/about-rightImg.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  color: #46302e;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}

p {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.about {
  margin-top: 80px;

  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;

    &-left {
      border-radius: 30px;
      max-width: 100%;
      height: auto;
      width: 350px;
    }

    &__right {
      border-radius: 30px;
      background: linear-gradient(102deg, #faeede 1.25%, #f9efdf 60.04%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0 0 30px;
      gap: 20px;

      &-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 15px;
        max-width: 500px;
      }

      img {
        max-width: 250px;
        height: auto;
      }
    }
  }


  @media (max-width: 1024px) {
    .about__wrapper {
      gap: 30px;

      &__right {
        padding: 25px 40px;

        &-text p {
          font-size: 18px;
        }

        img {
          max-width: 200px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .about__wrapper {
      flex-direction: column;
      gap: 30px;

      &__right {
        flex-direction: column;
        text-align: center;
        padding: 20px 25px;

        &-text {
          align-items: center;
          text-align: center;
        }

        img {
          display: none;
        }
      }
    }

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 18px;
    }
  }

  @media (max-width: 480px) {
    .about__wrapper__right {
      padding: 15px 20px;

      &-text {
        gap: 10px;
      }

      img {
        max-width: 150px;
      }
    }

    h2 {
      font-size: 24px;
    }

    p {
      font-size: 16px;
    }
  }
}
</style>
